import { makeStyles } from "tss-react/mui"
import FormControlLabel from "component-lib/Base/components/Form/FormControl/FormControlLabel"
import Checkbox from "component-lib/Base/components/Checkbox"
import { wmColor } from "themes-lib/wmTheme"
import { handleEnterPress } from "utils-lib/handleEnterPress"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"

const useStyle = makeStyles()({
  formControl: {
    color: wmColor.gray4,
  },
})

// eslint-disable-next-line react/prop-types
const LabeledCheckbox = ({
  listItem: { label, value, key },
  disabled = false,
  onChange = () => {},
  hideLabel = false,
  className = ``,
}) => {
  const { classes } = useStyle()

  const checkBox = (
    <Checkbox
      onChange={(e) => onChange({ value: e?.target?.checked, label, key })}
      checked={value}
      disabled={disabled}
      className="LabeledCheckbox__checkbox"
      tabIndex={-1}
      aria-hidden="true"
    />
  )

  const handleKeyPress = (e) => {
    if (
      e.keyCode === KEY_CODE_MAPPING.ENTER ||
      e.keyCode === KEY_CODE_MAPPING.SPACE_BAR
    ) {
      e.preventDefault()
      handleEnterPress(e, onChange({ value: !value, label, key }))
    }
  }

  return (
    <FormControlLabel
      className={`LabeledCheckbox ${className}`}
      tabIndex="0"
      onKeyDown={handleKeyPress}
      control={checkBox}
      role="checkbox"
      aria-checked={value}
      aria-labelledby={label}
      aria-label={`${label}`}
      label={
        !hideLabel && (
          <span
            className={`LabeledCheckbox__label ${classes.formControl}`}
            data-testid="LabeledCheckbox"
          >
            {label}
          </span>
        )
      }
    />
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// LabeledCheckbox.propTypes = {
//   listItem: PropTypes.shape({
//     label: PropTypes.string,
//     value: PropTypes.bool,
//     key: PropTypes.string,
//   }).isRequired,
//   disabled: PropTypes.bool,
//   onChange: PropTypes.func,
//   hideLabel: PropTypes.bool,
//   className: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// LabeledCheckbox.defaultProps = {
//   disabled: false,
//   onChange: () => {},
//   hideLabel: false,
//   className: ``,
// }

export default LabeledCheckbox
